export const menuItems = [
    {
        id: 1,
        label: "menuitems.menu.text",
        isTitle: true,
        role:["SuperAdmin",""],
        link: "/",
        subItems: [{
            id: 100, 
            isTitle: true,
            link: "/userroles",
            hide: true,
            role: ["SuperAdmin","StrAdmin"],
            subItems: [],
        },
        {
            id: 100, 
            isTitle: true,
            link: "/ouserbirimyetki",
            hide: true,
            role: ["SuperAdmin","StrAdmin"],
            subItems: [],
        },
        {
            id: 100,  
            link:"/logout",
            role:["*"],
            hide: true,
            subItems: []
        } 
    ]
    }, 

    { 
        id: 10,
        label: "menuitems.StrGenelTanimlar.text",
        icon: "bx bx-customize",
        link: "#",
        subItems: [
            {
                id: 10,
                label: "menuitems.StrGenelTanimlar.list.PlanDonemleri",
                link: "/StrPlanDonemleri",
                role:["SuperAdmin","StrAdmin"],
                parentId: 12
            },
            {
                id: 11,
                label: "menuitems.StrGenelTanimlar.list.StratejikAmaclar",
                link: "/StrStratejikAmaclar",
                role:["SuperAdmin","StrAdmin"],
                parentId: 12
            },
            {
                id: 40,
                label: "menuitems.StrSorgular.text",
                role:["SuperAdmin","StrAdmin"],
                subItems:[  ],
                link: "/StrSorgular",
            },
         
         
             
        ]
    },
    
    { 
        id: 2,
        label: "menuitems.StrHarcamaTakip.text",
        icon: "bx bx-dollar-circle",
        link: "#",
        subItems: [
            {
                id: 3,
                label: "menuitems.StrHarcamaTakip.list.StrHesapKodlari",
                link: "/StrHesapKodlari",
                role:["SuperAdmin","StrAdmin"],
                parentId: 12
            },
            {
                id: 3,
                label: "menuitems.StrHarcamaTakip.list.StrBirimHarcamaLimit",
                link: "/StrBirimHarcamaLimit",
                role:["SuperAdmin","StrAdmin"],
                parentId: 12
            },

            {
                id: 8,
                label: "menuitems.VeriGirisi.list.StrBirimKontrolTutarlari",
                link: "/StrBirimKontrolTutarlari",
                role:["SuperAdmin","StrAdmin"],
                parentId: 12
            } ,
            
           
            {
                id: 6,
                label: "menuitems.StrHarcamaTakip.list.GetBirimButce",
                link: "/GetBirimButce",
                role:["SuperAdmin","StrAdmin","StrHarcamaTakip"],
                parentId: 12
            },

         
         
         
             
        ]
    },
    

    {
        id: 9,
        label: "menuitems.KurumsalPerformans.text",
        icon: "bx bx-line-chart",
        link: "#",
        subItems: [
            
            {
                id: 12,
                label: "menuitems.KurumsalPerformans.list.HedefKartlari",
                link: "/StrHedefKartlari",
                role:["SuperAdmin","StrAdmin"],
                parentId: 12
            },
            {
                id: 12,
                label: "menuitems.KurumsalPerformans.list.StrBirimGosterge",
                link: "/StrBirimGosterge",
                role:["SuperAdmin","StrAdmin"],
                parentId: 12
            },
            /*{
                id: 13,
                label: "menuitems.KurumsalPerformans.list.HedefIsBirligiYapilanBirimler",
                link: "/StrHedefIsBirligiYapilanBirimler",
                role:["SuperAdmin","StrAdmin"],
                parentId: 12
            },*/
            {
                id: 14,
                label: "menuitems.KurumsalPerformans.list.DetayParametreTanımlari",
                link: "/StrDetayParametreTanimlari",
                role:["SuperAdmin","StrAdmin"],
                parentId: 12
            },
           
            {
                id: 15,
                label: "menuitems.KurumsalPerformans.list.DetayParametreHedefTanimlari",
                link: "/DetayParametreHedefTanimlari",
                role:["SuperAdmin","StrAdmin"],
                parentId: 12
            }, 
            {
                id: 17,
                label: "menuitems.KurumsalPerformans.list.RenkAciklamalari",
                link: "/StrRenkAciklamalari",
                role:["SuperAdmin","StrAdmin"],
                parentId: 12
            }  
             
        ]
    },


    {
        id: 21,
        label: "menuitems.IcKontrolEylemPlani.text",
        icon: "bx bx-chip",
        link: "#",
        subItems: [
           
            {
                id: 23,
                label: "menuitems.IcKontrolEylemPlani.list.StrKontrolStandart",
                link: "/StrKontrolStandart",
                role:["SuperAdmin","StrAdmin"],
                parentId: 12
            },
            {
                id: 23,
                label: "menuitems.IcKontrolEylemPlani.list.StrKontrolEylem",
                link: "/StrKontrolEylem",
                role:["SuperAdmin","StrAdmin"],
                parentId: 12
            },
            {
                id: 24,
                label: "menuitems.IcKontrolEylemPlani.list.StrKontrolTanim",
                link: "/StrKontrolTanim",
                role:["SuperAdmin","StrAdmin"],
                parentId: 12
            },
            {
                id: 25,
                label: "menuitems.IcKontrolEylemPlani.list.StrKontrolIsbirlikci",
                link: "/StrKontrolIsbirlikci",
                role:["SuperAdmin","StrAdmin"],
                parentId: 12
            },
           
          
             
             
        ]
    },
    {
        id: 27,
        label: "menuitems.KaliteOzDegerlendirme.text",
        icon: "bx bx-trophy",
        link: "#",
        subItems: [ 
            
            {
                id: 29,
                label: "menuitems.KaliteOzDegerlendirme.list.StrIcDegerTablo",
                link: "/StrIcDegerTablo",
                role:["SuperAdmin","StrAdmin"],
                parentId: 12
            } 
             
        ]
    },
    {
        id: 30,
        label: "menuitems.RiskYonetimi.text",
        icon: "bx bx-pulse",
        link: "#",
        subItems: [
            {
                id: 31,
                label: "menuitems.RiskYonetimi.list.Riskler",
                link: "/StrRiskler",
                role:["SuperAdmin","StrAdmin","StrRiskGiris"],
                parentId: 12
            },

            {
                id: 33,
                label: "menuitems.RiskYonetimi.list.StrRiskDeger",
                link: "/StrRiskDeger",
                role:["SuperAdmin","StrAdmin","StrRiskOylamaIslemleri"],
                parentId: 12
            },

       /*     {
                id: 33,
                 label: "menuitems.RiskYonetimi.list.StrRisklerGirislerCevap",
                 link: "/StrRisklerGirislerCevap",
                role:["SuperAdmin","StrAdmin","StrRiskCevaplamaIslemleri"],
                parentId: 12
            }, */

          {
                id: 33,
                 label: "menuitems.RiskYonetimi.list.StrRiskEylemPlani",
                 link: "/StrRiskEylemPlani",
                role:["SuperAdmin","StrAdmin","StrRiskGiris","StrRiskEylemCevap","StrPerformansGirisOnay"],
                parentId: 12
            }, 

            {
                id: 33,
                label: "menuitems.RiskYonetimi.list.StrRiskDegerlendirmeKriterTablosu",
                link: "/StrRiskDegerlendirmeKriterTablosu",
                role:["SuperAdmin","StrAdmin","StrRiskGiris","StrOperasyonelRiskGiris"],
                parentId: 12
            },
           
           
          
             
        ]
    },  

    {
        id: 30,
        label: "menuitems.ProsesKarti.text",
        icon: "bx bx-analyse",
        link: "#",
        subItems: [
            {
                id: 31,
                label: "menuitems.ProsesKarti.list.StrProses",
                link: "/StrProses",
                role:["SuperAdmin","StrAdmin"],
                parentId: 12
            },



            {
                id: 34,
                label: "menuitems.ProsesKarti.list.StrBirimProses",
                link: "/StrBirimProses",
                role:["SuperAdmin","StrAdmin"],
                parentId: 12
            },

           /* {
                id: 33,
                 label: "menuitems.ProsesKarti.list.StrProsesIsbirlikci",
                 link: "/StrProsesIsbirlikci",
                role:["SuperAdmin","StrAdmin"],
                parentId: 12
           },*/
           
           
          
             
        ]
    },  

    {
        id: 30,
        label: "menuitems.VeriGirisi.text",
        icon: "bx bx-add-to-queue",
        link: "#",
        subItems: [
            {
                id: 18,
                label: "menuitems.KurumsalPerformans.list.GostergeGirisi",
                link: "/StrGostergeGirisi",
                role:["SuperAdmin","StrAdmin","StrVeriGiris","StrPerformansGirisOnay"],
                parentId: 12
            },
          
             
            {
                id: 5,
                label: "menuitems.StrHarcamaTakip.list.StrBirimButceHarcamalari",
                link: "/StrBirimButceHarcamalari",
                role:["SuperAdmin","StrAdmin","StrHarcamaTakip","StrFaaliyetKullanici"],
                parentId: 12
            },  
            {
                id: 28,
                label: "menuitems.KaliteOzDegerlendirme.list.StrIcDegerGiris",
                link: "/StrIcDegerGiris",
                role:["SuperAdmin","StrAdmin","StrKaliteGiris"],
                parentId: 12
            },
            {
                id: 29,
                label: "menuitems.StrHarcamaTakip.list.StrOdenekTalep",
                link: "/StrOdenekTalep",
                role:["SuperAdmin","StrAdmin","StrHarcamaTakip"],
                parentId: 12
            },
            {
                id: 33,
                label: "menuitems.VeriGirisi.list.StrProsesGiris",
                link: "/StrProsesGiris",
                role:["SuperAdmin","StrAdmin","StrProsesOnay","StrProsesGiris"],
                parentId: 12
            },
            {
                id: 26,
                label: "menuitems.VeriGirisi.list.SoruFormu",
                link: "/StrKontrolGiris",
                role:["SuperAdmin","StrAdmin","StrIckontrolSoruGiris","StrIckontrolSoruOnay","StrIckontrolSoruOnayIptal"],
                parentId: 12
            },
            {
                id: 27,
                label: "menuitems.VeriGirisi.list.StratejikPlanDegerlendirme",
                link: "/StrStratejikPlanDegerlendirme",
                role:["SuperAdmin","StrAdmin","StrVeriGiris"],
                parentId: 12
            }       
          
             
        ]
    }, 
    {
        id: 30,
        label: "menuitems.Raporlar.text",
        icon: "bx bx-notepad",
        link: "#",
        subItems: [
            {
                id: 31,
                label: "menuitems.Raporlar.list.StrBirimButceHarcamalari",
                link: "/StrRaporBirimButceHarcamalari",
                role:["SuperAdmin","StrAdmin","StrRapor"],
                parentId: 12
            },
            {
                id: 32,
                label: "menuitems.Raporlar.list.StrKontrolGiris",
                link: "/StrIcKontrolRaporlar",
                role:["SuperAdmin","StrAdmin","StrRapor"],
                parentId: 12
            },
            {
                id: 32,
                label: "menuitems.Raporlar.list.StrIcDegerGiris",
                link: "/StrRaporIcDegerGiris",
                role:["SuperAdmin","StrAdmin","StrRapor"],
                parentId: 12
            },
            {
                id: 19,
                label: "menuitems.Raporlar.list.GostergeTablolari",
                link: "/GostergeTablolari",
                role:["SuperAdmin","StrAdmin","StrRapor"],
                parentId: 12
            },
            {
                id: 19,
                label: "menuitems.Raporlar.list.PerformansRaporlari",
                link: "/StrPerformansRaporlari",
                role:["SuperAdmin","StrAdmin","StrRapor"],
                parentId: 12
            },
            {
                id: 19,
                label: "menuitems.Raporlar.list.RiskRaporlari",
                link: "/RiskRaporlari",
                role:["SuperAdmin","StrAdmin","StrRapor"],
                parentId: 12
            },
            {
                id: 19,
                label: "menuitems.Raporlar.list.ProsesRaporlari",
                link: "/ProsesRaporlari",
                role:["SuperAdmin","StrAdmin","StrRapor"],
                parentId: 12
            },
             
        ]
    },  
    {
        id: 35,
        label: "menuitems.ODuyuru.text",
        icon: "bx bx-pin",
        role:["SuperAdmin","StrAdmin"],
        subItems:[ ],
        link: "/ODuyuru",
    }, 
    
    
   

];

